import React, { FC, useState } from 'react'
import TableForm from '../DatasetTable/TableForm'
import { Option } from 'helpers/selects'
import { CButton } from 'tabs/data/components/CButton'
import Modal from '@material-ui/core/Modal'
import * as S from './NewDatasetTable.style'

type NewDatasetTableProps = {
  options: Option[]
  onSubmit: (title: string, text: string, joinedTables: string[], synonyms: string[]) => Promise<void>
}

export const NewDatasetTable: FC<NewDatasetTableProps> = ({ options, onSubmit }) => {
  const [open, setOpen] = useState(false)

  const resetForm = () => {
    setOpen(false)
  }

  const handleCreateTable = async (title: string, text: string, joinedTables: string[], synonyms: string[]) => {
    await onSubmit(title, text, joinedTables, synonyms)
    resetForm()
  }

  return (
    <>
      <CButton label="+ Add Table" color="primary" onClick={() => setOpen(true)} />

      <Modal open={open}>
        <S.Container>
          <S.Title>New Table</S.Title>

          <TableForm
            isFromEdit
            cancelButtonLabel="Cancel"
            submitButtonLabel="Create table"
            inputDescription="Table name"
            textDescription="Description"
            options={options}
            joinedTables={[]}
            synonyms={[]}
            inputText=""
            textAreaContent=""
            onSubmit={handleCreateTable}
            onCancel={resetForm}
          />
        </S.Container>
      </Modal>
    </>
  )
}
